import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./library/container";
export const ButtonBlock = (p)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "cta container--sg align--center",
            children: /*#__PURE__*/ _jsx("a", {
                href: p.href,
                className: "button button--primary button--arrow",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "button__label",
                    children: p.caption
                })
            })
        })
    });
{}